import React from "react";
import { Tag } from "antd";
import {
  CheckCircleOutlined,
  PauseCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";

const STATUS_CONFIG = {
  active: {
    color: "green",
    label: "Active",
    icon: <CheckCircleOutlined />,
  },
  deactivate: {
    color: "orange",
    label: "Deactivated",
    icon: <PauseCircleOutlined />,
  },
  suspended: {
    color: "red",
    label: "Suspended",
    icon: <StopOutlined />,
  },
};

const UserStatusTag = ({ user }) => {
  const status = user.user_status || "deactivate";

  const config = STATUS_CONFIG[status];

  return (
    <Tag color={config.color} icon={config.icon}>
      {config.label}
    </Tag>
  );
};

export default UserStatusTag;
